:host {
  --md-link-bg-color: transparent;
  --md-link-text-color: var(--md-color--blue-duck--500);
  --md-link-text-color-hover: var(--md-color--blue-duck--600);
  --md-link-outline-focus: var(--md-outline-focus);
  --md-link-outline-offset-focus: 2px;
  --md-link-disabled-opacity: 0.4;
  --md-link-button-padding: 10px 20px;
  --md-link-button-border-radius: var(--md-border-radius--md);
  --md-link-text-align: center;
  --md-link-display: inline-block;
  display: var(--md-link-display);
}
.md-link {
  --md-link-display: inline-flex;
  align-items: center;
  color: var(--md-link-text-color);
  display: var(--md-link-display);
  font-family: var(--md-font-family--text-medium);
  gap: var(--md-spacing-unit--xs);
  text-decoration: none;
  transition: all var(--md-transition--slow);
}
.md-link--inline,
:host(.md-link--inline) {
  --md-link-display: inline;
  display: var(--md-link-display);
}
.md-link:focus-visible:not(.md-link.is-disabled),
.md-link.focusable {
  outline: var(--md-link-outline-focus);
  outline-offset: var(--md-link-outline-offset-focus);
}

.md-link.is-disabled:focus-visible {
  outline: 0;
}

.md-link--button {
  align-items: center;
  border-radius: var(--md-link-button-border-radius);
  cursor: pointer;
  display: inline-flex;
  justify-content: var(--md-link-text-align);
  padding: var(--md-link-button-padding);
}
@keyframes underlineAnimation {
  0% {
    background-image: linear-gradient(to left, transparent, transparent);
    background-size: 0 0.09em;
  }
  5% {
    background-image: linear-gradient(
      to left,
      var(--md-link-text-color),
      var(--md-link-text-color)
    );
    background-size: 0 0.09em;
  }
  100% {
    background-size: 100% 0.09em;
  }
}
.md-link .md-link--underline {
  background-image: linear-gradient(
    to left,
    var(--md-link-text-color),
    var(--md-link-text-color)
  );
  background-position: 100% 85%;
  background-repeat: no-repeat;
  background-size: 100% 0.09em;
  text-decoration: none;
}
.md-link:hover .md-link--underline {
  animation: underlineAnimation ease-in var(--md-transition--reg) forwards;
}
.md-link.is-disabled {
  opacity: var(--md-link-disabled-opacity);
  pointer-events: none;
  user-select: none;
  cursor: not-allowed;
}

/* Themes */

@define-mixin link-variant $color-name {
  /* CSS for variant->none */
  .md-link--button--$(color-name) {
    --md-link-bg-color: var(--md-btn-bg-fill-$(color-name));
    background: var(--md-link-bg-color);
    border: 1px solid var(--md-btn-bg-fill-$(color-name));
    --md-link-text-color: var(--md-btn-text-on-fill-$(color-name));
  }

  .md-link--button--$(color-name):hover {
    --md-link-bg-color: var(--md-btn-bg-fill-$(color-name)-hover);
    background: var(--md-link-bg-color);
    border: 1px solid var(--md-btn-bg-fill-$(color-name)-hover);
  }

  .md-link--button--$(color-name):active {
    border: 1px solid transparent;
    --md-link-bg-color: var(--md-btn-bg-fill-$(color-name)-clicked);
    background: var(--md-link-bg-color);
  }

  /* CSS for variant->bordered */
  .md-link--button--$(color-name).is-bordered {
    background: transparent;
    border: 1px solid var(--md-btn-bg-fill-$(color-name));
    --md-link-text-color: var(--md-btn-bg-fill-$(color-name));
    outline: 1px solid transparent;
  }

  .md-link--button--$(color-name).is-bordered:hover {
    --md-link-text-color: var(--md-btn-bg-fill-$(color-name)-hover);
    border: 1px solid var(--md-link-text-color);
    outline: 1px solid var(--md-link-text-color);
  }

  .md-link--button--$(color-name).is-bordered:active {
    --md-link-text-color: var(--md-btn-bg-fill-$(color-name)-clicked);
    border: 1px solid var(--md-link-text-color);
    outline: 1px solid var(--md-link-text-color);
  }

  /* CSS for variant->ghost */
  .md-link--button--$(color-name).is-ghost {
    background: transparent;
    border: 0;
    --md-link-text-color: var(--md-btn-bg-fill-$(color-name));
  }

  .md-link--button--$(color-name).is-ghost:hover {
    --md-link-text-color: var(--md-btn-bg-fill-$(color-name)-hover);
  }

  .md-link--button--$(color-name).is-ghost:active {
    --md-link-text-color: var(--md-btn-bg-fill-$(color-name)-clicked);
  }

  /* CSS for link colors */
  .md-link--$(color-name) {
    background: transparent;
    border: 0;
    --md-link-text-color: var(--md-btn-bg-fill-$(color-name));
  }

  .md-link--$(color-name):hover {
    --md-link-text-color-hover: var(--md-btn-bg-fill-$(color-name)-hover);
  }

  .md-link--$(color-name):active {
    --md-link-text-color: var(--md-btn-bg-fill-$(color-name)-clicked);
  }
}

/*--------------Blue-------------------*/
@mixin link-variant blue;

/*--------------Green-------------------*/
@mixin link-variant green;

/*--------------Magenta-------------------*/
@mixin link-variant magenta;

/*--------------Red-------------------*/
@mixin link-variant red;

/*--------------Purple-------------------*/
@mixin link-variant purple;

/*--------------Yellow-------------------*/
@mixin link-variant yellow;

/*--------------lightgrey-------------------*/
@mixin link-variant lightgrey;

/*--------------darkgrey-------------------*/
@mixin link-variant darkgrey;

/*--------------white-------------------*/
@mixin link-variant white;
